import DashboardMainComp from '@/components/features/store_owner/dashboard/DashboardMainComp';

const DashboardPageStoreOwner = () => {
  return (
    <>
      <DashboardMainComp />
    </>
  );
};

export default DashboardPageStoreOwner;
